module.exports = __webpack_public_path__ + "img/kari_shea_film6ng7vg_IwJcW.8289ff9f.jpg";